export default __webpack_public_path__ + "img/l_img.01000195.svg";